import { ShieldX } from 'lucide-react';
import { AuthLayout } from '../components/AuthLayout';

/** Shown when a Speedmax ID account has no FTTH NMS role (PRD AUTH-03b) or was deactivated by an admin. */
export function AccessDeniedPage() {
  const disabled = new URLSearchParams(window.location.search).get('reason') === 'disabled';
  return (
    <AuthLayout>
      <section className="fn-card fn-card--pad fn-auth__card">
        <div className="fn-empty" style={{ padding: 0 }}>
          <div className="fn-empty__icon">
            <ShieldX className="i i--xl" aria-hidden />
          </div>
          <h1 className="fn-empty__title">{disabled ? 'Akun dinonaktifkan' : 'Akses belum diberikan'}</h1>
          <p className="fn-empty__text">
            {disabled
              ? 'Akun Anda dinonaktifkan oleh Admin FTTH NMS. Hubungi Admin bila ini keliru.'
              : 'Akun Speedmax ID Anda belum punya peran untuk FTTH NMS. Minta Admin memberi peran Admin, NOC, Planner, atau Teknisi wilayah Anda di Speedmax ID, lalu masuk lagi.'}
          </p>
          <a href="/login" className="fn-btn fn-btn--secondary">
            Kembali ke halaman masuk
          </a>
        </div>
      </section>
    </AuthLayout>
  );
}
